
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[project_slug]/[event_slug]",
      function () {
        return require("private-next-pages/project/[project_slug]/[event_slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[project_slug]/[event_slug]"])
      });
    }
  